module.exports = new __parcel__URL__("integrations.a739abe5.svg").toString();